import { createContext, useContext, useEffect, useState } from 'react';

import { User } from 'src/shared/graphql/generated';

type SplitContext = {
  attributes: SplitIO.Attributes;
  client: Promise<SplitIO.IClient | undefined> | null;
  updateAttributes: (user?: User) => void;
  updateUserId: (id: string) => void;
};

const defaultValue: SplitContext = {
  attributes: {},
  client: null,
  updateAttributes: () => {},
  updateUserId: () => {},
};

const context = createContext(defaultValue);
const { Provider } = context;
const useSplit = () => {
  const {
    attributes,
    client: splitClient,
    updateUserId,
    updateAttributes,
  } = useContext(context);

  const wrappedClient = async () => {
    const client = await splitClient;

    return {
      getTreatment: (experiment: string, attr: SplitIO.Attributes = {}) =>
        client?.getTreatment(experiment, { ...attributes, ...attr }),
    };
  };
  return {
    client: wrappedClient(),
    updateUserId,
    updateAttributes,
  };
};

const useTreatment = (flagName: string) => {
  const [treatment, setTreatment] = useState<string | undefined>();

  const { attributes, client: clientPromise } = useContext(context);

  useEffect(() => {
    void (async () => {
      const client = await clientPromise;

      setTreatment(client?.getTreatment(flagName, { ...attributes }));
    })();
  }, [attributes, clientPromise, flagName]);

  return treatment;
};

export { SplitContext, Provider, defaultValue, useSplit, useTreatment };
